import { PreferenceCenter } from "@ua/web-sdk/lib/remote-data/preference-center"
import { RemoteDataResponse } from "@ua/web-sdk/lib/remote-data/client"
import axios, { AxiosInstance } from "axios"
import { throwIfNotSuccess } from "../../SubscriptionForm/client"
import { DeviceType } from "../utils"

export interface EmailPreferenceCenterClientInterface {
  getPreferenceCenter(
    id: string,
    deviceType: DeviceType
  ): Promise<PreferenceCenter | undefined>
}

export class EmailPreferenceCenterClient
  implements EmailPreferenceCenterClientInterface {
  requester: AxiosInstance
  appKey: string

  constructor(token: string, appKey: string) {
    if (!token.length) throw new Error("Invalid auth provided")
    if (!appKey.length) throw new Error("Invalid appKey provided")

    this.requester = axios.create({
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/vnd.urbanairship+json; version=3;",
      },
    })
    this.appKey = appKey
  }

  async getPreferenceCenter(
    id: string,
    deviceType: DeviceType
  ): Promise<PreferenceCenter | undefined> {
    const response = await this.requester.get<RemoteDataResponse>(
      `/api/remote-data/app/${this.appKey}/${deviceType}`
    )
    throwIfNotSuccess(response)

    if (!response.data.ok) {
      throw new Error("Request failed")
    }

    for (const payload of response.data.payloads) {
      if (payload.type === "preference_forms") {
        for (const form of payload.data.preference_forms) {
          if (form.form.id === id) return form.form
        }
      }
    }
  }
}
